export default __webpack_public_path__ + "static/media/Lora-Regular.6b74b8d6.ttf";